<terra-image-slider class="terra-image-slider" [ngClass]="{ 'empty': !holdingFiles().length }" [imageUrls]="holdingFiles()" />
@if (location() && showText()) {
  <div class="location-details">
    <mat-icon class="notranslate geo-pin">place</mat-icon>
    <span [innerHTML]="location()" class="lo_sensitive"></span>
  </div>
}